import {unminifyAccountName, _repName} from '../cads/unminify'
import {accountParent} from '../cads/get-account-options'

const filterSalesOrders = (salesOrderData, x, contact, fromDate, toDate, rep) => {
  let orders = (
    salesOrderData[x.s] == null ? [] : salesOrderData[x.s]
  ).concat(
    salesOrderData[x.i] == null ? [] : salesOrderData[x.i]
  )

  return filterSalesOrdersCadCard(orders, contact, fromDate, toDate, rep)
}

const filterSalesOrdersCadCard = (orders, contact, fromDate, toDate, rep) => {
  if (contact.length) {
    orders = orders.filter(order => contact.includes(order.account_name) || contact.includes(accountParent(order.account_name)))
  }

  if (rep != null && rep != 'All') {
    orders = orders.filter(order => _repName(order) == rep)
  }

  if (fromDate != null) {
    orders = orders.filter(x => x.date >= fromDate)
  }

  if (toDate != null) {
    orders = orders.filter(x => x.date <= toDate)
  }

  return orders
}

const filterShippedOrders = (orders, contact, fromDate, toDate, rep) => {
  if (contact.length) {
    orders = orders.filter(order => contact.includes(unminifyAccountName(order.a)) || contact.includes(accountParent(unminifyAccountName(order.a))))
  }

  if (rep != null && rep != 'All') {
    orders = orders.filter(order => _repName(order) == rep)
  }

  if (fromDate != null) {
    orders = orders.filter(x => x.d >= fromDate)
  }

  if (toDate != null) {
    orders = orders.filter(x => x.d <= toDate)
  }

  return orders
}

export {filterSalesOrders, filterSalesOrdersCadCard, filterShippedOrders}
